import React from "react";

const TableHeader = (props) => {

    return <thead>
        <tr>
            <th className="default-td">
                NOMBRE
            </th>
            <th className="default-td">
                TIPO
            </th>
            <th className="default-td">
                LIMITE
            </th>
            <th className="default-td" colSpan="2">
                &nbsp;
            </th>
        </tr>
    </thead>

}
export default TableHeader;